export const NOTIFY_SUCCESS = 'toast/push-notify-success';